import { render } from "./SuggestList.vue?vue&type=template&id=be92d4e0"
import script from "./SuggestList.vue?vue&type=script&lang=js"
export * from "./SuggestList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__